import {
  AfterViewInit,
  Component,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import { ExampleHeader } from './example-header/example-header.component';

@Component({
  selector: 'app-calendar-picker',
  templateUrl: './calendar-picker.component.html',
  styleUrls: ['./calendar-picker.component.scss'],
})
export class CalendarPickerComponent implements AfterViewInit {
  @ViewChild('getHeight') getDimension: any;
  @Output() calendarDimensions = new EventEmitter();
  @Output() selectedDate = new EventEmitter();
  checkHeight: number;
  selected: Date | null;
  calDimensions: {
    height: number;
    width: number;
  };
  date: Date = new Date();
  exampleHeader = ExampleHeader;
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calDimensions = {
        height: this.getDimension.nativeElement.clientHeight,
        width: this.getDimension.nativeElement.clientWidth,
      };
      this.calendarDimensions.emit(this.calDimensions);
      this.selectedDate.emit(this.date);
    });
  }
  calendarToggle() {
    this.calDimensions = {
      height: this.getDimension.nativeElement.clientHeight,
      width: this.getDimension.nativeElement.calendarWidth,
    };
    this.selectedDate.emit(this.date);
  }
}
